import { useIntl } from 'react-intl'

import Link, { LinkProps } from '@mui/material/Link'
import Tooltip from '@mui/material/Tooltip'

const TextLink = ({ children, href, ...otherProps }: LinkProps) => {
  const { formatMessage } = useIntl()
  return (
    <Tooltip title={formatMessage({ id: 'message.new_page_link' })} disableHoverListener disableTouchListener>
      <Link target="_blank" href={href} rel="noreferrer" color="text.primary" tabIndex={0} {...otherProps}>
        {children}
      </Link>
    </Tooltip>
  )
}
export default TextLink
